import { create } from 'zustand';
import { Provider } from '@/features/providers/types';

interface ProviderStore {
    selectedProvider: Provider | null;
    selectedProviderIds: number[];
    isCreateModalOpen: boolean;
    isDeleteModalOpen: boolean;
    sortField: string;
    sortDirection: 'asc' | 'desc';
    setSelectedProvider: (provider: Provider | null) => void;
    setSelectedProviderIds: (ids: number[]) => void;
    toggleProviderSelection: (id: number) => void;
    clearSelectedProviders: () => void;
    openCreateModal: () => void;
    closeCreateModal: () => void;
    openDeleteModal: () => void;
    closeDeleteModal: () => void;
    setSortField: (field: string) => void;
    setSortDirection: (direction: 'asc' | 'desc') => void;
    resetState: () => void;
}

export const useProviderStore = create<ProviderStore>((set) => ({
    selectedProvider: null,
    selectedProviderIds: [],
    isCreateModalOpen: false,
    isDeleteModalOpen: false,
    sortField: 'name',
    sortDirection: 'asc',
    setSelectedProvider: (provider) => set({ selectedProvider: provider }),
    setSelectedProviderIds: (ids) => set({ selectedProviderIds: ids }),
    toggleProviderSelection: (id) => set((state) => ({
        selectedProviderIds: state.selectedProviderIds.includes(id)
            ? state.selectedProviderIds.filter(providerId => providerId !== id)
            : [...state.selectedProviderIds, id]
    })),
    clearSelectedProviders: () => set({ selectedProviderIds: [] }),
    openCreateModal: () => set({ isCreateModalOpen: true }),
    closeCreateModal: () => set({ isCreateModalOpen: false, selectedProvider: null }),
    openDeleteModal: () => set({ isDeleteModalOpen: true }),
    closeDeleteModal: () => set({ isDeleteModalOpen: false, selectedProvider: null }),
    setSortField: (field) => set({ sortField: field }),
    setSortDirection: (direction) => set({ sortDirection: direction }),
    resetState: () => set({ 
        selectedProvider: null,
        selectedProviderIds: [], 
        isCreateModalOpen: false, 
        isDeleteModalOpen: false,
        sortField: 'name',
        sortDirection: 'asc'
    })
}));